// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__RFeqU","log":"ModalInventoryLogs_log__3SVk1","date":"ModalInventoryLogs_date__1_-Mz","userName":"ModalInventoryLogs_userName__eGUXE"};